import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Import analytics to initialize Segment (page() is called in analytics.js)
import './utils/analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
